import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { onboardingGet, onboardingPost } from "./api";

export default function VerifyEmail() {
  const [annual] = useState(() => new URLSearchParams(window.location.search).get("offerta") === "annuale");
  const [token] = useState(() => new URLSearchParams(window.location.hash.slice(1)).get("token") || "");
  const [csrf, setCsrf] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    window.history.replaceState(null, "", window.location.pathname);
    onboardingGet().then(data => setCsrf(data.csrf)).catch(e => setError(e.message));
  }, []);
  async function verify() {
    setBusy(true); setError("");
    try {
      const data = await onboardingPost("verify", { token }, csrf);
      window.location.replace(data.redirect_to);
    } catch (e) { setError(e.message); setBusy(false); }
  }
  return <main className="flex flex-1 items-center justify-center bg-slate-50 px-4 py-16"><section className="w-full max-w-lg rounded-3xl border bg-white p-8 shadow-lg">
    <MailCheck size={40} className="text-sky-600" /><h1 className="mt-5 text-2xl font-bold">Conferma la tua email</h1>
    <p className="mt-4 leading-7 text-slate-600">{annual ? "Conferma l’indirizzo per completare l’account e proseguire al pagamento di Norma Pro annuale. La licenza di un anno si attiva dopo il pagamento confermato." : "Conferma l’indirizzo per completare la creazione dell’account e scegliere il piano Norma."}</p>
    {error && <p role="alert" className="mt-5 rounded-xl bg-rose-50 p-4 text-sm text-rose-700">{error}</p>}
    {!token ? <p role="alert" className="mt-5 text-sm text-rose-700">Apri il link completo ricevuto via email. Se lo hai già utilizzato, accedi al tuo account.</p> : <button onClick={verify} disabled={!csrf || busy} className="mt-6 w-full rounded-xl bg-sky-600 px-4 py-3 font-semibold text-white disabled:opacity-50">{busy ? "Conferma in corso…" : "Conferma email e continua"}</button>}
    <div className="mt-6 flex justify-between text-sm text-sky-700"><Link to={annual ? "/norma-pro-annuale" : "/registrati"}>Richiedi un nuovo link</Link><Link to="/login">Accedi</Link></div>
  </section></main>;
}
